import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import IconPlus from 'design-system/icons/IconPlus';
import IconCircle from 'design-system/icons/IconCircle';
import { SettingsItem } from 'design-system/SettingsItem';
import useColors from 'hooks/useColors';
const CreateNewItemListFooter = ({ onPress, title, }) => {
    const colors = useColors();
    return (<SettingsItem title={title} onPress={onPress} style={styles.createNewListButton} renderIcon={() => (<View style={styles.iconContainer}>
          <IconCircle width={44} height={44}>
            <IconPlus color={colors.text.brand}/>
          </IconCircle>
        </View>)}/>);
};
export default memo(CreateNewItemListFooter);
const styles = StyleSheet.create({
    createNewListButton: {
        margin: 0,
        height: rem(78),
        paddingHorizontal: rem(16),
    },
    iconContainer: {
        marginRight: rem(16),
    },
});
